<template>
    <div class="ChildList" v-observe-visibility="VisibilityChanged" style="display:flex;flex-direction:column; max-height:85vh;">
        <div ref="divtophalf">
            <h2>TAY Client Enrollments <font-awesome-icon :icon="['fa', 'sync-alt']" v-on:click="RefreshDataTable()" class="olive-green-text pointer table-refresh client-list" /> <span v-b-tooltip.hover title="Hide/Show Filters"><font-awesome-icon :icon="ShowFilters ? 'eye' : 'eye-slash'" v-on:click="ToggleShowFilters()" class="pointer" /></span>  <b-button v-if="SelectedRows.length > 0" @click="ShowMassMessages" size="md" variant="secondary">SEND TEXT TO SELECTED YOUTH</b-button></h2>
            <div class="table-filters client-list"  v-show="ShowFilters">
                <div class="row">
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>Child Status:</label>
                            <select class="form-control" v-model="Filters.Status" @change="RefreshDataTable()">
                                <option value="All">All</option>
                                <option value="Active">Active</option>
                                <option value="Discharged">Discharged</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>Program:</label>
                            <select class="form-control" v-model="Filters.SubProgramID" @change="RefreshDataTable">
                                <option v-for="option in SubProgramOptions" v-bind:value="option.value">{{ option.text }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-sm-4" v-if="CheckPermission('TAY.Filters.ParentingStatus')">
                        <div class="form-group">
                            <label>Parenting Status:</label>
                            <select class="form-control" v-model="Filters.ParentingStatus" @change="RefreshDataTable">
                                <option value="All">All</option>
                                <option value="Parent">Parents</option>
                                <option value="Non-Parent">Non-Parents</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        Displaying {{NumberOfClients}} Records
                    </div>
                    <div class="col-sm-4"></div>
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>Search Clients:</label>
                            <input type="text" v-model="search" class="form-control" @input="RedrawTable()" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="overflow:auto;">
            <vuetable :fields="ChildrenTableOptions.Fields"
                      pagination-path=""
                      :api-mode="false"
                      class="vue-datatable"
                      :data-manager="DataManager"
                      ref="datatable"
                      track-by="Id"
                      id="childrendatatableid">

                <template slot="ChildRecordLink" scope="props">
                    <div class="ChildRecordLink">
                        <span class="underline pointer" @click="OpenChildRecord(props.rowData.Id, props.rowData)">{{ props.rowData.ClientName }}</span>
                    </div>
                </template>
                <template slot="ChildLocation" scope="props">
                    <div class="ChildLocation">
                        <span v-if="props.rowData.ClientProgramMembership.SubProgramID == 'ebda4d2b-fd9c-4135-804e-5132296063ca'">{{props.rowData.City}}</span>
                        <span v-else>{{props.rowData.Location}}</span>
                    </div>

                </template>
                <template slot="Designation" scope="props">
                    <div class="Designation">
                        <span v-if="props.rowData.ClientProgramMembership.SubProgramID == 'ebda4d2b-fd9c-4135-804e-5132296063ca'">
                            <span v-if="props.rowData.Client.Person.AgeInt >= 18">(TL) </span>
                            <span v-else>(IL) </span> 
                            {{props.rowData.Designation}}
                        </span>
                        <span v-else>{{props.rowData.Designation}}</span>
                    </div>

                </template>
            </vuetable>
        </div>

        <DispatchMassMessage ref="massmessages" />
    </div>
</template>

<script>
    //import services
    import { ClientsAPI } from '../../../services/api/Foster/ClientsAPI.js';
    
    //import components
    //import Vue from 'vue';
    import Vuetable from 'vuetable-2/src/components/Vuetable'
    import { EventBus } from '../../../services/event-bus.js';
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);
    import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
    library.add(faCaretDown);
    import { faEye } from '@fortawesome/free-solid-svg-icons';
    library.add(faEye);
    import { faEyeSlash } from '@fortawesome/free-solid-svg-icons';
    library.add(faEyeSlash);

    import { TableScrollerSupport } from "../../../mixins/TableScrollerSupport.js";
    import DispatchMassMessage from './DispatchMassMessage.vue';

    export default {
        mixins: [TableScrollerSupport],
        created() {
            this.$store.commit("Clients.ClientProfiles.Clear");
            this.$store.commit("Clients.ClientEnrollmentsList.Clear");
            const clientsAPI = new ClientsAPI(this.$baseURL);
            this.clientsAPI = clientsAPI;
            EventBus.$on('global-update-initiated', this.GetChildren);
        },
        beforeDestroy() {
            EventBus.$off('global-update-initiated');
        },
        props: [],
        data: function () {
            return {
                IsMounted: false,
                CaseManagers: '',
                NumberOfClients: '',
                search: "",
                Filters: {
                    Status: "Active",
                    SubProgramID: "",
                    ParentingStatus: "All"
                },
                
            };
        },
        methods: {
            RefreshDataTable() {
                this.GetChildren(true);
                
            },
            GetChildren(displayLoad = false) {
                this.$MasterAPI.ExecuteRequest("GET", "TAY/Clients/GetClientEnrollments", this.Filters, this.GetChildrenSuccess,()=>{}, displayLoad);
            },
            GetChildrenSuccess(response) {
                let filteredArray = response.data.data.filter(function (obj) {
                                return obj.Show !== false;
                            });
                            this.$store.commit("Clients.ClientEnrollmentsList.ReplaceListOnly", filteredArray);
                            this.$refs.datatable.refresh();
            },
            formatDate (value, fmt = 'MM/DD/YY', defaultVal = '') {
              return (value == null)
                ? defaultVal
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            OpenChildRecord(subProgramMembershipID, childRecordData) {
                this.$store.commit("Clients.ClientProfiles.Append", childRecordData);
                this.$parent.ChangePaneShown(subProgramMembershipID);
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            RedrawTable() {
                this.$refs.datatable.refresh();
            },
            DataManager(sortOrder, pagination) {
                let dataset = this.filteredList(this.$store.state.Clients.ClientEnrollmentsList);
                if (dataset.length > 0) {
                    if (sortOrder.length > 0) {
                        if (sortOrder[0].direction == 'asc') {
                            var firstComp = 1;
                            var secondComp = -1;
                        } else {
                            var firstComp = -1;
                            var secondComp = 1
                        }
                        return dataset.sort((a, b) => (this.$FindProperty(a, sortOrder[0].sortField) > this.$FindProperty(b, sortOrder[0].sortField)) ? firstComp : secondComp);
                    } else {
                        return dataset;
                    }
                    
                } else {
                    return [];
                }
            },
            filteredList(inputData) {
                let vm = this;
                let tData = inputData
                if (tData == null) {
                    return [];
                }
                let tFields = vm.$refs["datatable"].tableFields;
                let visibleData = [];
                tData.forEach(function (row, index) {
                    let rowData = [];
                    tFields.forEach(function (field) {
                        rowData.push(vm.$refs.datatable.renderNormalField(field, row));
                        
                    })
                    if (vm.search == "" || JSON.stringify(rowData).toLowerCase().includes(vm.search.toLowerCase())) {
                        visibleData.push(inputData[index]);
                    }
                });
                this.NumberOfClients = visibleData.length;
                return visibleData;                  
            },
            ShowMassMessages() {
                let vm = this;
                let selectedYouth = [];
                vm.SelectedRows.forEach(function (selectedRow) {
                    selectedYouth.push(vm.$store.state.Clients.ClientEnrollmentsList.filter(x => x.Id == selectedRow)[0]);
                });

                vm.$refs["massmessages"].ShowModal(selectedYouth);
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
        },
        components: {
            Vuetable,
            DispatchMassMessage
        },
        computed: {
            SubProgramOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramOptions"]();
            },
            SelectedRows: function () {
                if (this.IsMounted) {
                    console.log("yes");
                    return this.$refs["datatable"].selectedTo;
                } else {
                    console.log("no");
                    return [];
                }
                
            },
            ChildrenTableOptions: function() {
                let output = {
                    Fields: [
                        {
                            name: '__slot:ChildRecordLink',
                            title: 'Name',
                            sortField: 'ClientName',
                        },
                        {
                            name: 'ClientName',
                            title: 'Name',
                            visible: false
                        },
                        {
                            name: 'DOB',
                            title: "DOB",
                            callback: 'formatDate|MM/DD/YY',
                        },
                        {
                            name: 'ReferralDate',
                            title: "Enrollment Start",
                            callback: 'formatDate|MM/DD/YY',
                            sortField: 'ReferralDate',
                        },
                        {
                            name: 'DischargeDate',
                            title: "Termination",
                            callback: 'formatDate|MM/DD/YY',
                            sortField: 'DischargeDate',
                            //width: "15%"
                        },
                        //{
                        //    name: 'ServiceSchedule',
                        //    title: "Service Schedule",
                        //    sortField: 'ServiceSchedule',
                        //    dataClass: 'd-none d-xl-table-cell',
                        //    titleClass: 'd-none d-xl-table-cell',
                        //},
                        {
                            name: '__slot:ChildLocation',
                            title: 'Location',
                        },
                        {
                            name: '__slot:Designation',
                            title: 'Designation',
                            sortField: 'Designation',
                        }
                    ]
                };

                if (this.CheckPermission("TayTextMessaging")) {
                    output.Fields.unshift({
                        name: '__checkbox',
                        title: 'Select',
                        titleClass: 'center aligned',
                        dataClass: 'center aligned'
                    });
                }

                return output;
            }
        },
        mounted() {
            this.Filters.SubProgramID = this.SubProgramOptions[0].value;
            //Get Child Records*/
            this.GetChildren(true);
            this.IsMounted = true;
        }
    }
</script>

<style scoped>
    /*sticky table header*/
    /deep/ .vue-datatable thead {
        position: sticky;
        top: -1px;
        background: white;
    }
    /*no wrap text on columns*/
    /deep/ .vue-datatable tbody td {
        white-space: nowrap !important;
    }
</style>